module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00010"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4",
    attrs: {
      "id": "id00011"
    }
  }, [_vm._v("R.M.S. Mongolia, 12th May, 1904 Mayhap, Ella, here too distance lends its enchantment, and these gallant brethren would have quarrelled over Rosamund, or even had their long swords at each other's throat. Mayhap that Princess and heroine might have failed in the hour of her trial and never earned her saintly crown. Mayhap the good horse \"Smoke\" would have fallen on the Narrow Way, leaving false Lozelle a victor, and Masouda, the royal-hearted, would have offered up a strangely different sacrifice upon the altars of her passionate desire.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4",
    attrs: {
      "id": "id00012"
    }
  }, [_vm._v("Still, let us hold otherwise, though we grow grey and know the world for what it is. Let us for a little time think as we thought while we were young; when faith knew no fears for anything and death had not knocked upon our doors; when you opened also to my childish eyes that gate of ivory and pearl which leads to the blessed kingdom of Romance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4",
    attrs: {
      "id": "id00013"
    }
  }, [_vm._v("At the least I am sure, and I believe that you, my sister, will agree with me, that, above and beyond its terrors and its pitfalls, Imagination has few finer qualities, and none, perhaps, more helpful to our hearts, than those which enable us for an hour to dream that men and women, their fortunes and their fate, are as we would fashion them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4",
    attrs: {
      "id": "id00014"
    }
  }, [_vm._v("H. Rider Haggard. To Mrs. Maddison Green.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0